<template>
  <div>
    <van-nav-bar
      title="委托查询"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
  
    />
    <div class="" style="font-size: 13px">
      <van-row class="dateFilter"
        ><van-col span="4" class="rowStyle"><span>委托日期:</span></van-col>
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="1" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            size="small"
            style="height: 30px; background-color: #D02E27; border: 1px solid #D02E27; color:white"
            @click="getEntrust"
            >查询</van-button
          ></van-col
        >
      </van-row>
    </div>
    <div class="tableContent">
      <div class="tableheading" style="font-size: 14px">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>
              <p>股票</p>
              <p>代码</p>
            </th>
             <th>
              <p>方向</p>
              <p>开平</p>
            </th>
            <th>
              <p>委托价格</p>
              <p>成交价格</p>
            </th>
            <th>
              <p>委托数量</p>
              <p>成交数量</p>
            </th>
            <th>
              <p>买卖</p>
              <p>状态</p>
            </th>
            <th>
              <p>委托时间</p>
              <p>成交时间</p>
            </th>
          </tr>
        </table>
      </div>
      <div class="tabledata">
        <van-list
          v-model="loadingEntrust"
          :finished="finishedEntrust"
          finished-text="没有更多了"
        >
          <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
            <tr
              class="stock_td"
              v-for="(item, index) in entrustData.entrust"
              :key="index"
            >
              <td>
                <p>
                  <span
                  style="
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                  "
                  >{{ item.name }}</span
                ><br /><span>{{ item.code }}</span>
                </p>
              </td>
                <td>
                <p>{{ item.direction }}</p>
                <p>{{ item.position_open_close }}</p>
              </td>
              <td>
                <p >
                  {{ item.deal }}
                </p>
                <p>{{ parseFloat(item.price).toFixed(3) }}</p>
              </td>
             
              <td>
                <p>{{ item.number }}</p>
                <p>{{ item.finish }}</p>
              </td>
              <td>
                <p>{{ item.type }}</p>
                <p>{{ item.status }}</p>
              </td>
              <td>
                <p>{{ item.time }}&nbsp;{{ item.accurate }}</p>
                <p>{{ item.complete_time }}</p>
              </td>

            </tr>
          </table>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntrustInquiry",
  data() {
    return {
      entrustData: {
        date: [],
        entrust: [],
      },
      loadingEntrust: false,
      finishedEntrust: false,
      date: new Date(),
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getEntrust() {
      let that = this;
      that.loadingEntrust = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_entrust",
            token: window.sessionStorage.getItem("token"),
            start: that.startDate,
            end: that.endDate,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            let entrust = resData.data;
            let unwindData = [];
            for (let i = 0, len = entrust.length; i < len; i++) {
              if (entrust[i].depot_mold === 1) {
                unwindData.push(entrust[i]);
              }
            }
            that.unwindData = unwindData;
            that.entrustData.entrust = entrust;
            that.loadingEntrust = false;
            that.finishedEntrust = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingEntrust = false;
          that.finishedEntrust = true;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getEntrust();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  height: 130px;
  background: #ffffff;
  position: fixed;
  top: 42px;
  left: 0;
  width: 100%;
}

.dateFilter {
  padding: 10px 5px;
  /* position: fixed;
  top: 56px;
  left: 0;
  width: 100%; */
  border-bottom: 1px solid #ebedf0;
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableheadings {
  /* padding: 0px 5px; */
  /* position: fixed;
  top: 115px;
  left: 0;
  width: 100%; */
  border-bottom: 1px solid #ebedf0;
  padding: 10px 0px;
  text-align: center;
}

.tableheadings p {
  line-height: 20px;
  margin: 0;
}


.tabledata p {
  line-height: 20px;
  margin: 0;
  font-size: 12px;
}

.rowData {
  border-bottom: 1px solid rgb(235, 237, 240);
  padding: 10px 0px;
}
</style>

<style>

.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 140px; */
  padding-bottom: 10px;
  text-align: center;
  /* width: 100%; */
  width: 880px;
}

.tabledata {
  font-size: 14px;
  /* margin-top: 145px; */
}

.details {
  /* position: fixed;
  top: 110px;
  left: 0;
  width: 100%; */
  padding-bottom: 10px;
  text-align: center;
}

.details p {
  line-height: 20px;
  margin: 0;
}


.stockTable {
  text-align: left;
  width: 580px;
}

.stockTable p {
  margin: 5px 0px;
}


.stockTable th {
  width: 120px;
  text-align: center;
}
.stockTable td {
  width: 120px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  padding: 8px;
}

.tableContent {
  /* margin-top: 10px; */
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/EntrustInquiry.vue